module.exports = __webpack_public_path__ + "img/pro_feature_money_pool.f6d23c6.png";